import { Link } from '@heroui/react'
import { Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router'
import shouldBeLoggedIn from '#app/guards/should-be-logged-in'
import getBaseRoutePathByRole from '#app/lib/get-base-route-path-by-role'
import ModalsDispatcher from '#app/middlewares/dispatchers/modals-dispatcher'
import NotificationsDispatcher from '#app/middlewares/dispatchers/notifications-dispatcher'
import router from '#app/router'
import RouterContext from '#app/router-context'
import { Loading } from '#pages/common/loading'
import { SomethingWentWrong } from '#pages/common/something-went-wrong'
import { RootLayout } from '#widgets/layouts/root-layout'
import { PageEmptyState } from '#widgets/page-empty-state'
import getCurrentUserRoleInfo from '#shared/lib/auth/get-current-user-role-info'
import { combinePaths } from '#shared/lib/strings'
import { Role } from '#shared/model'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <NotificationsDispatcher>
      <ModalsDispatcher>
        <RootLayout>
          <Outlet />
        </RootLayout>
      </ModalsDispatcher>
    </NotificationsDispatcher>
  ),

  loader: async () => {
    let roleInfo = getCurrentUserRoleInfo()

    const currentPathname = router.state.location.pathname

    // Make redirects only if current path is /
    if (currentPathname !== combinePaths(router.basepath, '/')) {
      return
    }

    if (roleInfo.role === 'unknown') {
      await shouldBeLoggedIn()
      roleInfo = getCurrentUserRoleInfo()
    }

    // Role is still unknown
    if (roleInfo.role === 'unknown') {
      return
    }

    const baseRoutePath = getBaseRoutePathByRole(roleInfo.role as Role)
    throw redirect({ to: baseRoutePath })
  },

  errorComponent: () => (
    <RootLayout>
      <SomethingWentWrong withHardReload />
    </RootLayout>
  ),

  pendingComponent: () => (
    <RootLayout>
      <Loading />
    </RootLayout>
  ),

  notFoundComponent: () => (
    <RootLayout>
      <PageEmptyState buttonLabel="На главную" buttonProps={{ as: Link, href: '/' }}>
        Страница не найдена
      </PageEmptyState>
    </RootLayout>
  ),
})
